/**
 * The V3 reads resolve the caller's owner grants on the change request's
 * APPROVAL PARENT server-side and return one flat list, already expanded
 * through any owning user group — hence the null `user_group`. The legacy
 * GraphQL selection instead carries those grants on whichever node `getOwners`
 * walks to for that parent type, so each mapper mirrors this one list onto
 * every node the walk can land on.
 */
export const callerOwnerGrants = (
  currentUserOwnerList: { UserId: string | null }[]
) =>
  currentUserOwnerList.map(({ UserId }) => ({
    UserId,
    user_group: null,
  }));
